const ROOT_SELECTOR = '[data-expect-timeline]';
const BUTTON_SELECTOR = '[data-timeline-item-button]';
const DESC_SELECTOR = '[data-timeline-item-desc]';
const PROGRESS_SELECTOR = '[data-timeline-progress]';

/**
 * @param {HTMLElement} root
 */
function initTimelineSection(root) {
  const buttons = Array.from(root.querySelectorAll(BUTTON_SELECTOR), (element) => /** @type {HTMLButtonElement} */ (element));
  const progressElement = /** @type {HTMLElement | null} */ (root.querySelector(PROGRESS_SELECTOR));
  let activeIndex = 0;

  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry?.isIntersecting) {
        root.classList.add('expect-timeline--visible');
        observer.disconnect();
      }
    },
    { threshold: 0.1 }
  );

  observer.observe(root);

  /**
   * @param {number} index
   */
  function setActive(index) {
    activeIndex = index;

    buttons.forEach((button, buttonIndex) => {
      const isActive = buttonIndex === activeIndex;
      button.classList.toggle('expect-timeline__item--active', isActive);
      button.setAttribute('aria-expanded', String(isActive));

      const desc = /** @type {HTMLElement | null} */ (button.querySelector(DESC_SELECTOR));
      if (desc) {
        desc.hidden = !isActive;
      }
    });
  }

  const lineElement = /** @type {HTMLElement | null} */ (root.querySelector('.expect-timeline__line'));

  // Scroll-based progress highlighting
  function updateProgress() {
    if (!progressElement || !lineElement) return;

    const viewportHeight = window.innerHeight;
    const lineRect = lineElement.getBoundingClientRect();
    const lineHeight = lineRect.height;

    // Start filling when the top of the line enters the viewport bottom,
    // and finish when the bottom of the line leaves the viewport top.
    const progress = Math.max(
      0,
      Math.min(
        1,
        (viewportHeight - lineRect.top) / (viewportHeight + lineHeight)
      )
    );

    progressElement.style.transform = `scaleY(${progress})`;
  }

  // Throttle scroll events
  let scrollFrame = 0;
  function handleScroll() {
    if (scrollFrame) return;
    scrollFrame = requestAnimationFrame(() => {
      updateProgress();
      scrollFrame = 0;
    });
  }

  window.addEventListener('scroll', handleScroll);
  window.addEventListener('resize', updateProgress);
  updateProgress(); // Initial call

  buttons.forEach((button, index) => {
    button.addEventListener('click', () => {
      setActive(activeIndex === index ? -1 : index);
    });

    button.addEventListener('keydown', (event) => {
      const keyboardEvent = /** @type {KeyboardEvent} */ (event);
      if (keyboardEvent.key === 'Enter' || keyboardEvent.key === ' ') {
        keyboardEvent.preventDefault();
        button.click();
      }
    });
  });

  if (buttons.length > 0) {
    setActive(0);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll(ROOT_SELECTOR).forEach((element) => initTimelineSection(/** @type {HTMLElement} */ (element)));
  });
} else {
  document.querySelectorAll(ROOT_SELECTOR).forEach((element) => initTimelineSection(/** @type {HTMLElement} */ (element)));
}
